import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import '@/assets/sass/style.scss'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebook, faTwitter, faInstagram, faGooglePlay, faGithub, faGoogle } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faFacebook, faTwitter, faInstagram, faGooglePlay, faGithub, faGoogle, faEnvelope)

Vue.use(Vuex)

// Langue : FR par défaut (studio francophone), choix mémorisé
const savedLanguage = (typeof localStorage !== 'undefined' && localStorage.getItem('cbp-lang')) || 'fr'

const store = new Vuex.Store({
  state: {
    language: savedLanguage
  },
  mutations: {
    changeLanguage (state, language) {
      state.language = language
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('cbp-lang', language)
      }
    }
  }
})

Vue.component('font-awesome-icon', FontAwesomeIcon)

// Directive "v-reveal" : révèle l'élément quand il entre dans le viewport
Vue.directive('reveal', {
  inserted (el) {
    el.classList.add('reveal')
    if (typeof IntersectionObserver === 'undefined') {
      el.classList.add('is-visible')
      return
    }
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible')
          obs.unobserve(entry.target)
        }
      })
    }, { threshold: 0.15 })
    observer.observe(el)
  }
})

Vue.config.productionTip = false

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')